import {MI} from "../init";

/**
 * @constructor
 * @returns {LinesInfo}
 */
export default function LinesInfo() {

    this._initPos = -124;

    this._xPos = [50, 88, 126, 164];
    this._yPos = [16, 48, 79];

    /** @type {MadnesObject} */
    this._bg;

    /** @type {MadnesObject} */
    this._mainLight;

    /** @type {Object<MadnesObject>} */
    this._lights = {};

    /** @type {?MadnesTween} */
    this._mainLightTween;
}

LinesInfo.prototype.create = function() {

    this._bg = MI.addImg(MI.getWi() / 2, this._initPos, "lines_info_atlas").setFrameName("lines_background");
    this._bg.setAnchor(0.5, 0);

    this._mainLight = MI.addImg(-108, 0, "");
    this._bg.addChild(this._mainLight);

    for(var y = 0; y < this._yPos.length; y++) {

        for(var x = 0; x < this._xPos.length; x++) {

            var light = MI.addImg(this._xPos[x], this._yPos[y], "lines_info_atlas", "line_light_" + x + "_" + y);
            light.setFrameName("lines_light");
            light.setAnchor(0.5, 0.5);
            light.setVisible(false);

            this._lights[x + "_" + y] = light;
            this._mainLight.addChild(light);
        }
    }
};

//LinesInfo.prototype.drawLine = function(position, delay) {
//
//	for(var i = 0; i < position.length; i++) {
//		var x = position[i][0];
//		var y = position[i][1];
//
//		this._lights[x + "_" + y].setVisible(true);
//	}
//};

LinesInfo.prototype.hideAllLights = function() {
    for(var i in this._lights) {
        this._lights[i].setVisible(false);
        this._lights[i].setAlpha(1);
    }
};

/**
 * @param {boolean} show
 * @param {Array<MadnesObject>} lights
 */
LinesInfo.prototype._showHideLights = function(show, lights) {

    for(var k = 0; k < lights.length; k++) {
        lights[k].setVisible(show);
    }
};

/**
 * @param {Array<ServerResultWinline>} winlines
 */
LinesInfo.prototype.animDrawLinesBigWin = function(winlines) {

    var _self = this;

    this.hideAllLights();

    var WINLINEANIMDELAY = 0.4;
    var WINLINEANIMDELAYMIN = 0.25;

    var numLines = winlines.length;
    var animDelay = ((WINLINEANIMDELAY - WINLINEANIMDELAYMIN) * (1 - numLines/(70.5)) + WINLINEANIMDELAYMIN) * 1000;

    var sequence = Promise.resolve();

    var lightsAll = [];

    for(var i = 0; i < numLines; i++) {

        var positions = winlines[i].getPosition();

        (function(positions){ // define closure to capture i at each step of loop

            sequence = sequence.then(function(){

                return new Promise(function(res) {

                    for(var lk in _self._lights) {
                        _self._lights[lk].setVisible(false);
                    }

                    /** @type {Array<MadnesObject>} */
                    var lightsWin = [];

                    for(var k = 0; k < positions.length; k++) {

                        var x = positions[k][0];
                        var y = positions[k][1];

                        var light = _self._lights[x + "_" + y];
                        lightsWin.push(light);

                        if(lightsAll.indexOf(light) === -1) {
                            lightsAll.push(light);
                        }
                    }

                    _self._showHideLights(true, lightsWin);

                    /*var t = */MI.createTimer().add(function() {
//						_self._showHideLights(false, lightsWin);
                        res();
                    }, animDelay);

//					_self._timers.push(t);
                });
            });

        }(positions));
    }

    return sequence.then(function() {

        _self._showHideLights(true, lightsAll);
        _self._fadeInOutLights(animDelay);

    });
};

LinesInfo.prototype.stopAnimLinesBigWin = function() {
//	this._allLightsStopped = true;

    this._mainLightTween && this._mainLightTween.stop();
    this._mainLightTween = null;

    this._mainLight.setAlpha(1);
};

/**
 * @param {ServerResultWinline} winline
 */
LinesInfo.prototype.animWinLine = function(winline) {

    var _self = this;

    this.hideAllLights();

    var positions = winline.getPosition();

    for(var i = 0; i < positions.length; i++) {

        (function(i, positions) {

            var x = positions[i][0];
            var y = positions[i][1];

            var light = _self._lights[x + "_" + y];

            light.setVisible(true);
            light.setAlpha(0);

            MI.addTween().to(light, { 'alpha': 1 }, {
                'delay': i * 70,
                'duration': 1,
            });

        } (i, positions));
    }
};

LinesInfo.prototype._fadeInOutLights = function(duration) {

    this._mainLight.setAlpha(0);

    this._mainLightTween = MI.addTween().to(this._mainLight, { 'alpha': 1 } , {
        'duration': duration,
        'yoyo': true,
        'count': -1
    });

};

LinesInfo.prototype.animShow = function() {

    var _self = this;

    return new Promise(function(res) {

        _self._bg.setVisible(true);

        if(_self._bg.getPosY() === 0) {
            res();
            return;
        }

        MI.addTween().to(_self._bg, { 'y': 0 }, {
            'duration': 200,
            'callback': res
        });
    });
};

LinesInfo.prototype.show = function() {
    this._bg.setVisible(true);
    this._bg.setPosY(0);
};

LinesInfo.prototype.animHide = function() {

    var _self = this;

    return new Promise(function(res) {

        if(_self._bg.getPosY() === _self._initPos) {
            res();
            _self._bg.setVisible(false);
            return;
        }

        MI.addTween().to(_self._bg, { 'y': _self._initPos }, {
            'duration': 200,
            'callback': function() {
                _self._bg.setVisible(false);
                res();
            }
        });
    });
};

LinesInfo.prototype.hide = function() {
    this._bg.setVisible(false);
    this._bg.setPosY(this._initPos);
};